import checkDocument from "../../../utils/checkDocument";
import checkInputs from "../../../utils/checkInputs";

const validations = {
  editCostumer: function validationEditUser(updatedCostumer) {
    const errors = {};
    if (!checkInputs.notNull(updatedCostumer.nombres)) {
      errors.nombres = "Es necesario.";
    } else if (!checkInputs.isAlphanumeric(updatedCostumer.nombres)) {
      errors.nombres = "Los nombres solo contienen letras.";
    } else if (updatedCostumer.nombres.length > 300) {
      errors.nombres = "No ingrese más de 300 caracteres.";
    }

    let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
    if (updatedCostumer.telefono) {
      if (!checkInputs.isAlphanumeric(updatedCostumer.telefono)) {
        errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
      } else if (
        updatedCostumer.telefono.length < 7 ||
        updatedCostumer.telefono.length > 12
      ) {
        errors.telefono =
          "La cantidad de dígitos debe estar entre 7 (convencionales) a 12 (teléfonos celulares).";
      } else if (!regex.test(updatedCostumer.telefono)) {
        errors.telefono = 'El formato del teléfono no es correcto.';
      }
    }

    if (updatedCostumer.direccion) {
      if (!checkInputs.isAlphanumeric(updatedCostumer.direccion)) {
        errors.direccion =
          "Solo ingrese: letras, números, '#', '.' o paréntesis";
      } else if (updatedCostumer.direccion.length > 300) {
        errors.direccion = "No ingrese más de 300 caracteres.";
      }
    }

    if (!checkInputs.notNull(updatedCostumer.correo)) {
      errors.correo = "El correo es necesario.";
    } else if (!checkInputs.validationEmail(updatedCostumer.correo)) {
      errors.correo =
        "El correo es incorrecto. Debe contener el usuario, @ y el dominio.";
    } else if (updatedCostumer.correo.length > 300) {
      errors.correo = "No ingrese más de 300 caracteres.";
    }

    if (updatedCostumer.cliente.tipoReceptor === "04") {
      if (checkInputs.notNull(updatedCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "No ingresar la ubicación geográfica, el cliente es extranjero."
      }
    }
    if (updatedCostumer.cliente.tipoReceptor === "01" || updatedCostumer.cliente.tipoReceptor === "03") {
      if (!checkInputs.notNull(updatedCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "La ubicación geográfica es necesaria."
      }
    }
    return errors;
  },
  addCostumer: function validationAddCostumer(newCostumer) {
    const errors = {};
    //Validaciones si el tipo de receptor es 01 contribuyente o 03 gobierno
    if (newCostumer.tipoReceptor === "01" || newCostumer.tipoReceptor === "03") {
      if (!checkInputs.notNull(newCostumer.idCliente)) {
        errors.idCliente = "Ingrese la identificación del usuario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.idCliente)) {
        errors.idCliente =
          "No puede contener caracteres especiales, solo letras o números.";
      } else if (newCostumer.idCliente.length > 300) {
        errors.idCliente = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.direccion)) {
        errors.direccion = "Ingrese la dirección es necesario si el cliente es contribuyente.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.direccion)) {
        errors.direccion = "No ingrese caracteres especiales.";
      } else if (newCostumer.direccion.length > 300) {
        errors.direccion = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.nombres)) {
        errors.nombres = "El nombre o la razón social es necesario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.nombres)) {
        errors.nombres = "Ingrese caracteres alfanuméricos.";
      } else if (newCostumer.nombres.length > 300) {
        errors.nombres = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.digitoVerificador)) {
        errors.digitoVerificador = "El dígito verificador es necesario.";
      } else if (newCostumer.digitoVerificador.length !== 2 ) {
        errors.digitoVerificador = "Ingrese dos caracteres del dígito verificador, por ejemplo 01.";
      }

      if (!checkInputs.notNull(newCostumer.tipoContribuyente)) {
        errors.tipoContribuyente = "El tipo de contribuyente es necesario.";
      }

      if (!checkInputs.notNull(newCostumer.paisReceptor)) {
        errors.paisReceptor = "El país receptor es necesario.";
      } else if (newCostumer.paisReceptor !== "PA") {
        errors.paisReceptor = "El país receptor debe ser Panamá";
      }

      if (checkInputs.notNull(newCostumer.paisExtranjero)) {
        errors.paisExtranjero = "No ingresar el país extranjero, el cliente es contribuyente o de gobierno."
      }

      if (checkInputs.notNull(newCostumer.paisReceptorDesc)) {
        errors.paisReceptorDesc = "No ingresar el nombre del país extranjero, el cliente es contribuyente o de gobierno."
      }

      if (!checkInputs.notNull(newCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "La ubicación geográfica es necesaria."
      }
    }

    //Validaciones si el tipo de receptor es 04 extranjero
    if (newCostumer.tipoReceptor === "04") {

      if (!checkInputs.notNull(newCostumer.idCliente)) {
        errors.idCliente = "Ingrese la identificación del usuario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.idCliente)) {
        errors.idCliente =
          "No puede contener caracteres especiales, solo letras o números.";
      } else if (newCostumer.idCliente.length > 300) {
        errors.idCliente = "No ingrese más de 300 caracteres.";
      }

      if (checkInputs.notNull(newCostumer.digitoVerificador)) {
        errors.digitoVerificador = "No ingresar el dígito verificador, el cliente es extranjero.";
      }

      if (checkInputs.notNull(newCostumer.tipoContribuyente)) {
        errors.tipoContribuyente = "No ingresar el tipo de contribuyente, el cliente es extranjero."
      }

      if (!checkInputs.notNull(newCostumer.paisReceptor)) {
        errors.paisReceptor = "El país receptor es necesario.";
      } else if (newCostumer.paisReceptor === "PA") {
        errors.paisReceptor = "El país receptor no debe ser Panamá, el cliente es extranjero.";
      }

      if (checkInputs.notNull(newCostumer.paisExtranjero)) {
        if (!checkInputs.isAlphanumeric(newCostumer.paisExtranjero)) {
          errors.paisExtranjero = "Ingrese caracteres alfanuméricos.";
        } else if (newCostumer.paisExtranjero.length > 100) {
          errors.paisExtranjero = "No ingrese más de 100 caracteres.";
        }
      }

      if (!checkInputs.notNull(newCostumer.nombres)) {
        errors.nombres = "El nombre del cliente es necesario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.nombres)) {
        errors.nombres = "Ingrese caracteres alfanuméricos.";
      } else if (newCostumer.nombres.length > 300) {
        errors.nombres = "No ingrese más de 300 caracteres.";
      }

      if (checkInputs.notNull(newCostumer.direccion)) {
        if (!checkInputs.isAlphanumeric(newCostumer.direccion)) {
          errors.direccion = "No ingrese caracteres especiales.";
        } else if (newCostumer.direccion.length > 300) {
          errors.direccion = "No ingrese más de 300 caracteres.";
        }
      }

      if (newCostumer.paisReceptor === "ZZZ" && !checkInputs.notNull(newCostumer.paisReceptorDesc)) {
        errors.paisReceptorDesc = "El nombre del país es necesario."
      }

      if (checkInputs.notNull(newCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "No ingresar la ubicación geográfica, el cliente es extranjero."
      }

    }

    if (newCostumer.tipoReceptor === "02") {
      if (!checkInputs.notNull(newCostumer.idCliente)) {
        errors.idCliente = "Ingrese la identificación del usuario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.idCliente)) {
        errors.idCliente =
          "No puede contener caracteres especiales, solo letras o números.";
      } else if (newCostumer.idCliente.length > 300) {
        errors.idCliente = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.direccion)) {
        errors.direccion = "Ingrese la dirección es necesario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.direccion)) {
        errors.direccion = "No ingrese caracteres especiales.";
      } else if (newCostumer.direccion.length > 300) {
        errors.direccion = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.nombres)) {
        errors.nombres = "El nombre o la razón social es necesario.";
      } else if (!checkInputs.isAlphanumeric(newCostumer.nombres)) {
        errors.nombres = "Ingrese caracteres alfanuméricos.";
      } else if (newCostumer.nombres.length > 300) {
        errors.nombres = "No ingrese más de 300 caracteres.";
      }

      if (!checkInputs.notNull(newCostumer.paisReceptor)) {
        errors.paisReceptor = "El país receptor es necesario.";
      } else if (newCostumer.paisReceptor !== "PA") {
        errors.paisReceptor = "El país receptor debe ser Panamá";
      }

      if (checkInputs.notNull(newCostumer.paisExtranjero)) {
        errors.paisExtranjero = "No ingresar el país extranjero, el cliente es consumidor final."
      }

      if (checkInputs.notNull(newCostumer.paisReceptorDesc)) {
        errors.paisReceptorDesc = "No ingresar el nombre del país extranjero, el cliente es condumidor final."
      }

    }

    //Validaciones opcionales para todo cliente
    if (checkInputs.notNull(newCostumer.sucursal)) {
      if (newCostumer.sucursal.length > 4) {
        errors.sucursal = "No ingrese más de 4 caracteres.";
      }
    }

    let regexCoordenadas = new RegExp("[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}[,]{1}[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}");
    if (checkInputs.notNull(newCostumer.coordenadasSucursal)) {
      if (newCostumer.coordenadasSucursal.length > 22) {
        errors.coordenadasSucursal = "No ingrese más de 22 caracteres.";
      } else if (!regexCoordenadas.test(newCostumer.coordenadasSucursal)) {
        errors.coordenadasSucursal = 'El formato de la coordenada de la sucursal no es correcto.';
      }
    }

    let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
    if (checkInputs.notNull(newCostumer.telefono)) {
      if (!checkInputs.isAlphanumeric(newCostumer.telefono)) {
        errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
      } else if (newCostumer.telefono.length > 12 || newCostumer.telefono.length < 7) {
        errors.telefono = 'No ingrese entre 7 y 12 caracteres.';
      } else if (!regex.test(newCostumer.telefono)) {
        errors.telefono = 'El formato del teléfono no es correcto.';
      }
    }

    //Validaciones obligatorias para todo cliente
    if (!checkInputs.notNull(newCostumer.correoCliente)) {
      errors.correoCliente = "El correo del usuario es necesario.";
    } else if (!checkInputs.validationEmail(newCostumer.correoCliente)) {
      errors.correoCliente =
        "El correo del usuario es erroneo. Ingrese un correo con el formato user@ejemplo.com";
    } else if (newCostumer.correoCliente.length > 300) {
      errors.correoCliente = "No ingrese más de 300 caracteres.";
    }


    return errors;
  },
};

export default validations;
